import styledComponents from 'styled-components';
import Avatar from '@mui/material/Avatar';

type StyleAvatarProps = {
  img: string;
};

export const StyledAvatar = styledComponents(Avatar)<StyleAvatarProps>(
  (props) => ({
    margin: '12px',
    backgroundImage: `url(${props.img})`,
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    svg: {
      display: 'none !important',
    },
  })
);
